const Footer = () => (
  <footer className="text-themeSelColor bg-headerbgcolor text-center py-3 w-full fixed left-0 right-0 bottom-0">
    &copy; Copyright 2014-2025 <b>Ranger Online</b>. All Rights Reserved
  </footer>
);

export default Footer;
